import React from 'react';
import propTypes from 'prop-types';
import styled from 'styled-components';
import classnames from 'classnames';

import {selectFieldType, textFieldType} from '../../common/common-prop-types';
import {grid, gridCell} from '../../common/grid';
import useAutoComplete from '../../common/use-auto-complete';
import Button from '../buttons/button';
import Form from '../form-controls/common/form';
import LabelledCheckbox from '../form-controls/labelled-checkbox';
import SelectField from '../form-fields/select-field';
import TextField from '../form-fields/text-field';

const Fields = styled.div`
    ${grid({rows: 4, rowGap: '40px'})}
`;

const StyledButton = styled(Button)`
    display: block;
    margin: 48px auto 0;
`;

const Relationship = styled(SelectField)`
    ${gridCell({row: 1, column: 1})}
`;

const FullName = styled(TextField)`
    ${gridCell({row: 2, column: 1})}
`;

const PhoneNumber = styled(TextField)`
    ${gridCell({row: 3, column: 1})}
`;

const EmailAddress = styled(TextField)`
    ${gridCell({row: 4, column: 1})}
`;

export default function OtherReporterDetails({
    className,
    relationship,
    fullName,
    phoneNumber,
    emailAddress,
    contactLabel,
    isContact,
    onChangeIsContact,
    submitButtonText,
    isSubmitting,
    onSubmit,
}) {
    return (
        <Form
            className={classnames('OtherReporterDetails', className)}
            autoComplete={useAutoComplete()}
            noValidate
            onSubmit={onSubmit}
        >
            <Fields>
                <Relationship
                    {...relationship}
                    placeholder={relationship.label}
                    disabled={isSubmitting}
                />
                <FullName
                    {...fullName}
                    type="text"
                    disabled={isSubmitting}
                />
                <PhoneNumber
                    {...phoneNumber}
                    type="tel"
                    disabled={isSubmitting}
                />
                <EmailAddress
                    {...emailAddress}
                    type="email"
                    disabled={isSubmitting}
                />
            </Fields>

            <LabelledCheckbox
                label={contactLabel}
                disabled={isSubmitting}
                checked={isContact}
                onChange={onChangeIsContact}
            />

            <StyledButton
                type="submit"
                color="primary"
                isTall
                disabled={isSubmitting}
            >
                {submitButtonText}
            </StyledButton>
        </Form>
    );
}

OtherReporterDetails.propTypes = {
    className: propTypes.string,
    relationship: selectFieldType,
    fullName: textFieldType,
    phoneNumber: textFieldType,
    emailAddress: textFieldType,
    contactLabel: propTypes.string,
    isContact: propTypes.bool,
    onChangeIsContact: propTypes.func,
    submitButtonText: propTypes.string,
    isSubmitting: propTypes.bool,
    onSubmit: propTypes.func,
};
